<template>
  <div class="Number-Section">
    <div class="Number-Section__title">
      {{title}}
      <el-button v-if="editable" type="text" style="margin-left:16px;" @click="add">添加</el-button>
    </div>
    <div v-if="visiable['picker']" class="Number-Section-picker">
      <el-cascader
        v-model="assetId"
        :options="options"
        expand-trigger="hover"
        style="width:500px;"
        @change="pushItem"
      />
    </div>
    <el-row>
      <el-col :span="12" v-for="(item, i) in data" :key="i">
        <div v-if="editable" class="NumberInput NumberInput--editable">
          <div class="NumberInput__cell _left">{{item.name}}</div>
          <div
            class="NumberInput__cell _center"
          >{{item.brandName}} {{item.modelName}} {{item.sizeName}}</div>
          <div class="NumberInput__cell _right NumberInput__input-wrap">
            <input
              class="NumberInput__input"
              type="number"
              :value="item.count"
              @input="e => setCount(e.target.value, item, i)"
            />
          </div>
        </div>
        <div class="NumberInput" v-else>
          <div class="NumberInput__cell _left">{{item.name}}</div>
          <div
            class="NumberInput__cell _center"
          >{{item.brandName}} {{item.modelName}} {{item.sizeName}}</div>
          <div class="NumberInput__cell _right">{{item.count}}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listHouseAssetOptions } from './fetch'

export default {
  props: {
    editable: {
      type: Boolean,
      required: true,
    },

    data: {
      type: Array,
      default: () => [],
    },

    title: {
      type: String,
      required: true,
    },

    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      options: [],

      visiable: {
        picker: false,
      },

      assetId: null,
    }
  },

  watch: {
    editable(val) {
      if (val) {
        // 最好是只加载一次
        listHouseAssetOptions(this.id).then(options => {
          console.log({ options })
          this.options = options
        })
      }
    },
  },

  methods: {
    add() {
      this.visiable.picker = true
    },
    pushItem(v) {
      const id = v[1].id
      if (this.data.find(o => o.id === id)) {
        this.$message.warning('已有该物品，不可重复添加哦～')
        return
      }
      this.data.push(v[1])
      this.visiable.picker = false
    },
    setCount(val, item, i) {
      if (val < 0) {
        item.count = 0
        console.log('已经到底啦，再点就没啦～')
        this.data.splice(i, 1)
      } else {
        item.count = Number(val)
      }
    },
  },
}
</script>

<style lang="scss">
$scolor: #ccc;

.Number-Section {
  margin-bottom: 16px;
}
.Number-Section__title {
  font-size: 14px;
  color: #666666;
  font-weight: 400;
}

.NumberInput {
  margin: 8px;
  border: 1px solid $scolor;
  width: 90%;
  max-width: 500px;
  color: #666666;
  padding-left: 100px;
  padding-right: 60px;
  position: relative;
}
.NumberInput .NumberInput__cell {
  background: #efefef;
}
.NumberInput.NumberInput--editable .NumberInput__input-wrap {
  background: transparent;
}

.NumberInput:after {
  content: '';
  display: block;
  clear: both;
}
.NumberInput__cell {
  margin: 0;
  padding: 4px;
  box-sizing: border-box;
  flex-shrink: 0;
  height: 36px;
  line-height: 28px;
}
.NumberInput__cell:not(:last-child) {
  border-right: 1px solid $scolor;
}
.NumberInput__cell._left {
  width: 100px;
  position: absolute;
  left: 0;
  top: 0;
}
.NumberInput__cell._center {
  text-align: left;
}
.NumberInput__cell._right {
  width: 60px;
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
}
.NumberInput__input {
  width: 100%;
  height: 100%;
  cursor: pointer;
  text-align: center;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0);
  font-size: 14px;
  font-weight: 500;
}
.Number-Section-picker {
  margin: 16px 8px;
}

input[type='number']::-webkit-inner-spin-button {
  width: 24px;
  height: 40px;
  position: relative;
  right: -10px;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/ReletContractForm/NumberSection.vue